import React from 'react';

const IconSmile1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M42.8373 14.9994C42.7806 13.9106 42.4758 13.0419 41.9481 12.3459C40.4873 10.4199 37.6334 10.2802 35.8922 11.957C33.7998 13.9718 29.8108 16.8931 24.2731 16.8931C18.5956 16.8931 14.2998 13.8226 12.0912 11.8065C10.6382 10.4802 8.42984 10.3258 6.87196 11.5267C5.83914 12.3227 5.24439 13.4334 5.16263 14.9994C5.14048 16.7742 5.06687 17.7973 5.4688 19.9594C5.93327 22.4569 7.49505 35.8876 23.3301 37.2878H24.6698C40.5049 35.8876 42.0667 22.4569 42.5311 19.9594C42.9331 17.7973 42.8594 16.7742 42.8373 14.9994Z" fill="#FFB7FA" />
  </svg>
);

export default IconSmile1;
